import { TemplateRef } from '@angular/core';

export enum DialogActionType {
  CONFIRM = 'confirm',
  CANCEL = 'cancel', 
  CUSTOM = 'custom',
  UNDERSTOOD = 'understood'
}

export interface DialogData {
  isCustom: boolean;
  title: string;
  showTitle: boolean;
  content?: string[];
  contentTemplate?: TemplateRef<void>;
  lottiePath?: string;
  actions: DialogDataActions[];
}

export interface DialogDataActions {
  type: DialogActionType;
  text: string;
  icon?: string;
  action?: () => void;
}
